import {
   DRIVING_LICENSE_DURATION_OPTIONS,
   TAXI_INSURANCE_COVERAGE_TYPE_OPTIONS,
   TAXI_VEHICLE_TYPE_OPTIONS,
   YES_NO_CHOICE_OPTIONS
} from "@constants/dropdown-choices";
import {isInLabelValueArrayAsString, isValidPositiveNumber} from "@utils/validators";
import {isNotStringOrEmptyString} from "@utils/string";
import {isDateGreaterThenToday} from "@utils/date-time";

export const ValidateStep5Data = (data) => {

    const msgList = [/*{
       name : 'test',
        message : 'Hold!',
    }*/];
    
    if(!isInLabelValueArrayAsString(data.taxiVehicleType,TAXI_VEHICLE_TYPE_OPTIONS)) {
       msgList.push({
          name : 'taxiVehicleType',
          message : 'Please select the type of taxi vehicle'
       });
    }
    
    if(isNotStringOrEmptyString(data.taxiLicenseIssuerCouncil)) {
       
       msgList.push({
          name: `taxiLicenseIssuerCouncil`,
          message: `Please specify which council issued your taxi license`
       });
       
    }
    
    if(isNotStringOrEmptyString(data.taxiBadgeDate)) {
       msgList.push({
          name: `taxiBadgeDate`,
          message: `Please specify the date your taxi badge was issued`
       });
    } else if(isDateGreaterThenToday(data.taxiBadgeDate)) {
       
       msgList.push({
          name: `taxiBadgeDate`,
          message: `The date your taxi badge was issued cannot be in the future!`
       });
       
    }

    if(isNotStringOrEmptyString(data.taxiMaxPassengers)) {
       msgList.push({
          name: `taxiMaxPassengers`,
          message: `Please specify the maximum number of passengers your taxi can carry`
       });
    } else if(!isValidPositiveNumber(data.taxiMaxPassengers)) {
       
       msgList.push({
          name: `taxiMaxPassengers`,
          message: `The maximum number of passengers your taxi can carry must be a positive number or 0!`
       });
       
    }
    
    if(!isInLabelValueArrayAsString(data.isEnrolledWithLocalTaxiCompany,YES_NO_CHOICE_OPTIONS)) {
       msgList.push({
          name: `isEnrolledWithLocalTaxiCompany`,
          message: `Please specify if you are enrolled with a local taxi company`
       });
    }
    
    if('Yes' === data.isEnrolledWithLocalTaxiCompany) {
       
       if(isNotStringOrEmptyString(data.localTaxiCompanyName)) {
          msgList.push({
             name: `localTaxiCompanyName`,
             message: `Please specify the name of the local taxi company`
          });
       }
    }
    
    if(!isInLabelValueArrayAsString(data.doesAcceptCashOrCardPayment,YES_NO_CHOICE_OPTIONS)) {
       msgList.push({
          name: `doesAcceptCashOrCardPayment`,
          message: `Please specify if you accept cash or card payment`
       });
    }
    
    if(!isInLabelValueArrayAsString(data.doesAcceptCashOrCardPayment,YES_NO_CHOICE_OPTIONS)) {}
    
    if(!isInLabelValueArrayAsString(data.taxiCoverageType,TAXI_INSURANCE_COVERAGE_TYPE_OPTIONS)) {
       msgList.push({
          name: `taxiCoverageType`,
          message: `Please specify the type of taxi insurance coverage`
       });
    }
    
    
    /*if(!isInLabelValueArrayAsString(data.taxiLicenseDuration,DRIVING_LICENSE_DURATION_OPTIONS)) {
       
       msgList.push({
          name: `taxiLicenseDuration`,
          message: `Please specify how many years you held the taxi license`
       });
       
    }*/
    
    if(!isInLabelValueArrayAsString(data.isAnUberDriver,YES_NO_CHOICE_OPTIONS)) {
       msgList.push({
          name: `isAnUberDriver`,
          message: `Please specify if you are an Uber driver`
       });
    }
    
    
    return msgList;
    

}